import React from "react";
import ReactDOM from "react-dom";
import { SizeMe } from "react-sizeme";

import "./styles.css";

function App() {
  return (
    <div className="App">
      <SizeMe monitorHeight>
        {({ size }) => (
          <div className="Demo">
            <div className="Values">
              <span className="value">{parseInt(size.width)}w</span>{" "}
              <span className="value">{parseInt(size.height)}h</span>
            </div>
          </div>
        )}
      </SizeMe>
    </div>
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
